import { render, staticRenderFns } from "./iqc_inspection_detail.vue?vue&type=template&id=4d60900a&scoped=true&"
import script from "./iqc_inspection_detail.vue?vue&type=script&lang=js&"
export * from "./iqc_inspection_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d60900a",
  null
  
)

export default component.exports